import React, { Component } from 'react';
import { isEmpty, size } from "lodash";

import Pagination from '../../../container/MUI/Pagination';
import { Edit, AddRounded, EditRounded } from '@mui/icons-material';

import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button, 
    Box,
    TableContainer,
    Fab,
    Grid
} from '@mui/material';
import EmployeeForm from './EmployeeForm';
import { MONTHS } from '../../../utils/generalFuncs';
import TabsContent from '../../common/TabsContent';
import SearchBar from '../../common/SearchBar';
import Creatable from '../../common/Creatable';

class EmployeesList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        employee: {},
        openUpdate: false,
        selectedEmployee: {},
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }
    getEmployeeList = () => {
        const { EMPLOYEES, SERVICES, FUNCTIONS, searchEmployee } = this.props
        const { rowsPerPage, page } = this.state;

        if (!isEmpty(EMPLOYEES) ){
            let list = Object.values(EMPLOYEES)
            if( !isEmpty(searchEmployee.value) ){
                list = [EMPLOYEES[searchEmployee.value]]
            }
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => 
                (
                    <TableRow hover key={item.employee_id} className="clickable"
                        onClick={() => this.setState({ openDetails: true, employee: item })}    
                        title="Voir le Détail"
                    >
                        <TableCell>{item.employee_matricule}</TableCell>
                        <TableCell>{new Date(item.employee_hire_date).toLocaleDateString('fr-FR')}</TableCell>
                        <TableCell>{item.employee_lastname}</TableCell>
                        <TableCell>{item.employee_firstname}</TableCell>
                        <TableCell>{SERVICES && SERVICES[item.employee_service].service_name}</TableCell>
                        <TableCell>{FUNCTIONS && FUNCTIONS[item.employee_function].function_name}</TableCell>
                        <TableCell>
                            <IconButton 
                                onClick={ () => this.setState({
                                    openUpdate: true,
                                    selectedEmployee: item
                                }) }
                            >
                                <EditRounded />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )
            )
        }
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openUpdate: false,
            employee: {},
            selectedEmployee: {},
            openForm: false,
            openEmployee: false,
        });
    };    
        
    render() {
        const { EMPLOYEES } = this.props;
        const { rowsPerPage, page, openUpdate, employee, openEmployee, selectedEmployee } = this.state;
        console.log('==== STATE EMPLOYEES LIST ================================');
        console.log(this.state);
        console.log('====================================');
        return (
               
            <Box>
                {openEmployee &&
                    <EmployeeForm handleClose={() => this.setState({ openEmployee: false })} {...this.props} />
                }
                {openUpdate && selectedEmployee &&
                    <EmployeeForm update handleClose={() => this.setState({ openUpdate: false })} {...this.props} employee={selectedEmployee} />
                }
                <Typography variant="h6" id="tableTitle">
                    Liste des Employé.es
                </Typography>
                <Grid container spacing={2}>
                    <Grid item sm={10} >
                        <Creatable
                            label="Employé"
                            id="searchEmployee"
                            options={Object.values(EMPLOYEES).map( item => ({
                                label: `${item.employee_matricule} - ${item.employee_lastname.toUpperCase()} ${item.employee_firstname}`,
                                value: item.employee_id
                            }))}
                            value={this.props.searchEmployee}
                            onChange={this.props.handleChangeEmployee}
                        />
                    </Grid>
                    <Grid item sm={2} >
                        <Fab color="secondary" 
                            onClick={() => this.setState({ openEmployee: true })} 
                            title="Créer Employé.e"
                            size="small"
                        >
                            <AddRounded />
                        </Fab>
                    </Grid>
                </Grid>
                <Box p={1} style={{textAlign: "right"}}>
                </Box>
                {!isEmpty(EMPLOYEES) && 
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Maticule</TableCell>
                                    <TableCell>Date D'embauche</TableCell>
                                    <TableCell>Nom</TableCell>
                                    <TableCell>Prénom</TableCell>
                                    <TableCell>Service</TableCell>
                                    <TableCell>Fonction</TableCell>
                                    <TableCell>Modifier</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.getEmployeeList()}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={7}
                                        count={Object.keys(EMPLOYEES).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table> 
                    </TableContainer>
                }
            </Box>
                       
        );
    }
}

export default EmployeesList;